module.exports = __webpack_public_path__ + "static/media/aroldo-pensando-direita.4e05217d.svg";